// src/pages/ApplicationProtect.js
import React, { useState } from 'react';
import Layout from '../components/Layout';
import ComingSoon from '../components/ComingSoon';

function ApplicationProtect() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedApplication, setSelectedApplication] = useState('Minecraft');

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const renderFormFields = () => {
        switch(selectedApplication) {
            case 'DefaultSSH':
                return (
                    <>
                        <div className="mb-4">
                            {/* Replace with your actual image path */}
                            <label className="block text-sm font-bold mb-2">Block SSH Port</label>
                            <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-600" />
                        </div>
                        <div className="mb-4">
                            {/* Replace with your actual image path */}
                            <label className="block text-sm font-bold mb-2">Whitelist</label>
                            <select className="bg-transparent border-none text-white appearance-none focus:outline-none">
                                <option>192.168.1.1</option>
                                {/* Add other options here */}
                            </select>
                        </div>
                        {/* Add more SSH related fields */}
                    </>
                );
            case 'Minecraft':
                return (
                    <>
                        <div className="mb-4">
                            {/* Replace with your actual image path */}
                            <label className="block text-sm font-bold mb-2">Minecraft Java</label>
                            <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-600" />
                        </div>
                        <div className="mb-4">
                            {/* Replace with your actual image path */}
                            <label className="block text-sm font-bold mb-2">Minecraft Bedrock</label>
                            <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-600" />
                        </div>
                        <div className="mb-4">
                            {/* Replace with your actual image path */}
                            <label className="block text-sm font-bold mb-2">Include banned-players.txt Bans?</label>
                            <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-600" />
                        </div>
                        {/* Add more Minecraft related fields */}
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <Layout>
            <ComingSoon>
            <div className="p-8">
                <h1 className="text-4xl font-bold text-white mb-8">Application Protect</h1>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <button onClick={openModal} className="py-2 px-4 rounded bg-custom-gray text-white hover:bg-gray-800 transition duration-300 ease-in-out">
                        Add Application Filter
                    </button>
                    <button onClick={openModal} className="py-2 px-4 rounded bg-custom-gray text-white hover:bg-gray-800 transition duration-300 ease-in-out">
                        Custom Application
                    </button>
                </div>
                <div className="bg-dark-card rounded-lg shadow-md p-4 text-white">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className="border-b border-custom-gray">
                                    <th className="text-left p-2">Application Name</th>
                                    <th className="text-left p-2">Rules</th>
                                    <th className="text-left p-2">IP Addresses</th>
                                    <th className="text-left p-2">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="border-b border-custom-gray">
                                    <td className="p-2 flex items-center">
                                        <img src="/path-to-your-minecraft-icon.png" alt="Minecraft" className="h-6 w-6 mr-2"/>
                                        Minecraft
                                    </td>
                                    <td className="p-2">6</td>
                                    <td className="p-2">167.94.253.0/24</td>
                                    <td className="p-2">
                                        <button className="bg-custom-gray hover:bg-black text-white font-bold py-1 px-2 rounded inline-flex items-center">
                                            Manage Application Rules
                                        </button>
                                    </td>
                                </tr>
                                <tr className="border-b border-custom-gray">
                                    <td className="p-2 flex items-center">
                                        <img src="/path-to-your-default-ssh-icon.png" alt="Default SSH" className="h-6 w-6 mr-2"/>
                                        Default SSH
                                    </td>
                                    <td className="p-2">3</td>
                                    <td className="p-2">167.94.253.0/24</td>
                                    <td className="p-2">
                                        <button className="bg-custom-gray hover:bg-black text-white font-bold py-1 px-2 rounded inline-flex items-center">
                                            Manage Application Rules
                                        </button>
                                    </td>
                                </tr>
                                {/* Repeat for each row as needed */}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-dark-card rounded-lg shadow-xl p-6 text-white relative flex w-full max-w-4xl">
                        <div className="w-full p-4">
                            <button onClick={closeModal} className="absolute top-0 right-0 m-4 text-xl leading-none">&times;</button>
                            <h2 className="text-xl font-bold mb-4">Edit Application Rules</h2>
                            
                            <div className="mb-4">
                                <label className="block text-sm font-bold mb-2">Application</label>
                                <div className="flex items-center bg-custom-gray p-2 rounded">
                                    <select 
                                        className="bg-transparent border-none text-white appearance-none focus:outline-none"
                                        value={selectedApplication}
                                        onChange={(e) => setSelectedApplication(e.target.value)}
                                    >
                                        <option value="Minecraft">Minecraft</option>
                                        <option value="DefaultSSH">Default SSH</option>
                                    </select>
                                </div>
                            </div>

                            {/* Conditional Form Content */}
                            {renderFormFields()}
                        </div>
                    </div>
                </div>
            )}
            </ComingSoon>
        </Layout>
    );
}

export default ApplicationProtect;